import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';

import './marketplace-list.scss';

export function MarketPlaceList({ entry, className = '' }) {
  const { title } = entry;
  const links = entry.children().map(link => link.getAllMetadata());
  const colClassName = classnames({ 'col item-link': className === 'right-column' });

  return (
    <div className="mb-3 small hr-list marketplace-list">
      <SectionHeading>{title}</SectionHeading>
      <ul className="list-unstyled">
        {links.map(item => (
          <li key={item['item-title']} className={classnames('p-1 marketplace-item', className)}>
            <Container>
              <Row>
                <Col className="d-flex justify-content-between pe-0 ps-0 marketplace-item-box">
                  <div className={colClassName}>
                    <a className="fw-bold mb-0_25" href={item['item-link']}>
                      {item['item-title']}
                    </a>
                    <p className="h6 fw-normal mb-0">{item['item-description']}</p>
                  </div>
                  <a className={colClassName} href={item['item-link']}>
                    <img src={getStaticImageUrl(item['item-image'])} alt={item['item-title']} />
                  </a>
                </Col>
              </Row>
            </Container>
          </li>
        ))}
      </ul>
    </div>
  );
}

MarketPlaceList.propTypes = {
  entry: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};
